import React, { useState, useEffect } from 'react';
import { Accordion, Card} from 'react-bootstrap';
import { CustomerContext } from './clientFocus/CustomerContext'; 
import { Tabs, Tab } from 'react-bootstrap';
import ClientSearch from './clientFocus/ClientSearch';
import SelectedClientDetails from './clientFocus/SelectedClientDetails';
import SelectedClientJobs from './clientFocus/SelectedClientJobs';
import SelectedClientActivity from './clientFocus/SelectedClientActivity';
import CustomerEmails from './clientFocus/ClientEmails';


const ClientFocus: React.FC = () => {
  const [customerId, setCustomerId] = useState<string | null>(null);
  const [activeKey, setActiveKey] = useState<string | null>("0");
  const [openSearchCard, setOpenSearchCard] = useState(true);
  const [savedEmailsRefreshTrigger, setSavedEmailsRefreshTrigger] = useState(0);

  const handleSetCustomerId = (id: string | null) => {
    setCustomerId(id);
    setOpenSearchCard(false);
  };

  const refreshSavedEmails = () => {
    setSavedEmailsRefreshTrigger(prev => prev + 1);
  };

  useEffect(() => {
    setActiveKey(null);
  }, [customerId]);

  const handleAccordionClick = (eventKey: string | null) => {
    setActiveKey(activeKey === eventKey ? null : eventKey);
  };
  
  return (
    <CustomerContext.Provider value={{ customerId, setCustomerId: handleSetCustomerId, setOpenSearchCard, openSearchCard }}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <Accordion activeKey={activeKey} onSelect={(e) => handleAccordionClick(e as string | null)}>
              <div style={{ margin: '10px' }}>
                <Card>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <h3 className="card-title">Select Client</h3>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ClientSearch />
                    </Accordion.Body>
                  </Accordion.Item>
                </Card>
              </div>
              <div style={{ margin: '10px' }}>
                <Card>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <h3 className="card-title">Customer Details</h3>
                    </Accordion.Header>
                    <Accordion.Body>
                      <SelectedClientDetails customerId={customerId} />
                    </Accordion.Body>
                  </Accordion.Item>
                </Card>
              </div>
              <div style={{ margin: '10px' }}>
                <Card>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      <h3 className="card-title">Jobs</h3>
                    </Accordion.Header>
                    <Accordion.Body>
                      <SelectedClientJobs customerId={customerId} />
                    </Accordion.Body>
                  </Accordion.Item>
                </Card>
              </div>
              <div style={{ margin: '10px' }}>
                <Card>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      <h3 className="card-title">Activity</h3>
                    </Accordion.Header>
                    <Accordion.Body>
                      <SelectedClientActivity customerId={customerId} />
                    </Accordion.Body>
                  </Accordion.Item>
                </Card>
              </div>
              <div style={{ margin: '10px' }}>
                <Card>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      <h3 className="card-title">Correspondence</h3>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Tabs defaultActiveKey="saved" id="uncontrolled-tab-example" className="mb-3">
                        <Tab eventKey="new" title="New Emails">
                          <CustomerEmails 
                            customerId={customerId} 
                            onEmailSaved={refreshSavedEmails}
                          />
                        </Tab>
                      </Tabs>
                    </Accordion.Body>
                  </Accordion.Item>
                </Card>
              </div>
            </Accordion>
          </div>
        </div>
      </div>
    </CustomerContext.Provider>
  );
};

export default ClientFocus;